import React from 'react';
import PropTypes from 'prop-types';

class Timer extends React.Component {
  constructor(props) {
    super(props);
    this.start = Date.now();

    this.timerHandler = {};

    this.state = {
      timeOut: this.props.delayMs,
    };
  }

  static PropTypes = {
    expireAtMs: PropTypes.number.isRequired,
  };

  static defaultProps = {
    expiredCallback: () => {},
  };

  /**
   * @description formates time in ms -> MM:SS
   * @param {number} ms - time in ms
   *
   * @returns {string} time in MM:SS
   *
   * @usage formatTime(423000) // -> "07:03"
   */
  formatTime = ms => {
    function formatNumber(number) {
      return number < 10 ? `0${number}` : `${number}`;
    }

    const mins = Math.floor(ms / 60000);
    const secs = Math.floor((ms / 1000) % 60);

    return formatNumber(mins) + ':' + formatNumber(secs);
  };

  componentDidUpdate() {
    if (window.expire_date - Date.now() <= 0) {
      if (this.props.timerDisable) this.props.timerDisable();
    }
  }

  componentWillUnmount() {
    clearInterval(this.timerHandler);
  }

  componentDidMount() {
    // update timeOut and close recent popup if timeOut === 0
    this.timerHandler = setInterval(() => {
      // let timeOut = this.start + this.props.delayMs - Date.now();
      let timeOut = this.props.expireAtMs - Date.now();
      if (timeOut < 0) {
        timeOut = 0;
        this.props.expiredCallback(true);
      }

      this.setState({
        timeOut,
      });

      if (timeOut <= 0) {
        // clearInterval(this.timerHandler);
      }
    }, 1000);
  }

  render() {
    const timerStr = this.props.static ? 'timer-static' : 'timer';
    const visibleStatus = !isNaN(this.state.timeOut) ? 'visible' : 'hidden';
    return this.props.enable ? (
      <div className={timerStr} style={{ visibility: visibleStatus }}>
        Оплатить билет можно в течение{' '}
        <span>{this.formatTime(this.state.timeOut)}</span>
      </div>
    ) : null;
  }
}

export default Timer;
